/**
 * Skogstad Sport – Nyheter: skjulte faner hentes etter innlasting (16.10.2026)
 * ---------------------------------------------------------------------------
 * Seksjonen: sections/skogstad-nyheter.liquid (se «SKJULTE FANER HENTES ETTER
 * INNLASTING» øverst der). Fanebyttet selv bor fortsatt i
 * assets/skogstad-globalt.js – dette skriptet fyller bare panelene.
 *
 * Bare første fane bygges med siden. De andre står som tomme skall med
 * data-skogstad-panel-last="N" og fylles herfra:
 *
 *   1. I bakgrunnen når seksjonen nærmer seg skjermen (IntersectionObserver,
 *      600 px i forkant), ett panel om gangen.
 *   2. Med det samme kunden peker på, fokuserer eller trykker en fane.
 *   3. Blir et skall synlig før det er fylt (raskt klikk, piltast), holdes
 *      høyden fra forrige panel så siden ikke hopper, og panelet fylles så
 *      fort svaret kommer.
 *
 * Kortene kommer fra samme seksjon via Section Rendering API:
 *   <denne adressen>?section_id=<seksjonen>&page=10N
 * og er nøyaktig samme markup som før. Kortenes lyttere er delegert fra
 * document (skogstad-globalt.js), så de virker uten videre. Det eneste kortet
 * trenger per node – tabbar fargebrikke og synlig mobilutløser for
 * hurtigkjøp – gjøres i slaaPaKort(), likt initProduktkort().
 *
 * Feiler hentingen, står panelet med «Se alle»-lenka (den er i skallet), og
 * neste peking eller trykk prøver igjen.
 */

(function () {
  'use strict';

  if (window.skogstadNyheterFaner) return;
  window.skogstadNyheterFaner = true;

  var SEKSJON = '[data-skogstad-nyheter]';
  var SKALL = '[data-skogstad-panel-last]';
  var FANE = '[data-skogstad-fane]';
  var LISTE = '.skogstad-nyheter__liste';

  var underveis = {};

  function adresse(seksjonId, nr) {
    var url = new URL(window.location.href);
    url.hash = '';
    url.searchParams.set('section_id', seksjonId);
    url.searchParams.set('page', String(100 + parseInt(nr, 10)));
    return url.toString();
  }

  function slaaPaKort(rot) {
    var kort = rot.querySelectorAll('[data-skogstad-kort]');
    for (var i = 0; i < kort.length; i++) {
      var forste = kort[i].querySelector('[data-skogstad-brikke][aria-pressed="true"]') ||
        kort[i].querySelector('[data-skogstad-brikke]');
      if (forste) forste.setAttribute('tabindex', '0');
    }
    var utlosere = rot.querySelectorAll('[data-skogstad-hurtig-utloser]');
    for (var j = 0; j < utlosere.length; j++) utlosere[j].removeAttribute('hidden');
  }

  function ferdig(panel) {
    panel.removeAttribute('aria-busy');
    panel.style.minHeight = '';
  }

  function hent(panel) {
    if (!panel || !panel.hasAttribute('data-skogstad-panel-last')) return Promise.resolve();
    if (underveis[panel.id]) return underveis[panel.id];

    var seksjon = panel.closest(SEKSJON);
    var seksjonId = seksjon && seksjon.getAttribute('data-section-id');
    var nr = panel.getAttribute('data-skogstad-panel-last');
    if (!seksjonId || !nr) return Promise.resolve();

    var jobb = fetch(adresse(seksjonId, nr), { credentials: 'same-origin' })
      .then(function (svar) {
        if (!svar.ok) throw new Error('HTTP ' + svar.status);
        return svar.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var nytt = doc.getElementById(panel.id);
        var nyListe = nytt && nytt.querySelector(LISTE);
        var liste = panel.querySelector(LISTE);
        if (!nyListe || !liste || nytt.hasAttribute('data-skogstad-panel-last')) {
          throw new Error('Fant ikke panelet i svaret');
        }

        // Samme <ul> beholdes: railen (skogstad-globalt.js) observerer den
        // allerede og måler seg selv på nytt når innholdet endrer bredde.
        liste.innerHTML = nyListe.innerHTML;
        panel.removeAttribute('data-skogstad-panel-last');
        slaaPaKort(panel);

        // Bildene tones inn med temaets AOS (data-aos="image-fade-in"), som
        // bare kjenner nodene som fantes da den startet. Impulse gjør det
        // samme etter sine egne AJAX-innlastinger.
        if (window.AOS && typeof window.AOS.refreshHard === 'function') {
          window.AOS.refreshHard();
        }

        if (!panel.hidden && typeof panel.skogstadTegnRail === 'function') {
          panel.skogstadTegnRail();
        }
        ferdig(panel);
      })
      .catch(function () {
        // Prøv igjen ved neste peking/trykk.
        delete underveis[panel.id];
        ferdig(panel);
      });

    underveis[panel.id] = jobb;
    return jobb;
  }

  function panelForFane(fane) {
    var id = fane && fane.getAttribute('aria-controls');
    return id ? document.getElementById(id) : null;
  }

  // Alle skall i én seksjon, ett om gangen, så forsiden ikke sender tjue
  // kall samtidig.
  function hentSeksjon(seksjon) {
    var skall = Array.prototype.slice.call(seksjon.querySelectorAll(SKALL));
    return skall.reduce(function (kjede, panel) {
      return kjede.then(function () { return hent(panel); });
    }, Promise.resolve());
  }

  // Høyden på panelet som vises nå, så et tomt panel kan holde plassen.
  function husHoyde(seksjon) {
    var paneler = seksjon.querySelectorAll('[data-skogstad-panel]');
    for (var i = 0; i < paneler.length; i++) {
      if (!paneler[i].hidden && paneler[i].offsetHeight) {
        seksjon.skogstadPanelHoyde = paneler[i].offsetHeight;
        return;
      }
    }
  }

  // Peking, fokus eller trykk på en fane: hent panelet med det samme, og husk
  // høyden på panelet som vises før fanebyttet skjuler det. Capture, så dette
  // kjører før fanebyttet i skogstad-globalt.js.
  function vedIntensjon(evt) {
    var fane = evt.target && evt.target.closest ? evt.target.closest(FANE) : null;
    if (!fane) return;
    var seksjon = fane.closest(SEKSJON);
    if (seksjon) husHoyde(seksjon);
    hent(panelForFane(fane));
  }

  ['pointerover', 'pointerdown', 'focusin', 'keydown'].forEach(function (type) {
    document.addEventListener(type, vedIntensjon, true);
  });

  // Et skall som blir synlig før det er fylt: hold høyden og hent.
  var synlighet = new MutationObserver(function (endringer) {
    for (var i = 0; i < endringer.length; i++) {
      var panel = endringer[i].target;
      if (panel.hidden || !panel.hasAttribute('data-skogstad-panel-last')) continue;
      var seksjon = panel.closest(SEKSJON);
      if (seksjon && seksjon.skogstadPanelHoyde) {
        panel.style.minHeight = seksjon.skogstadPanelHoyde + 'px';
      }
      panel.setAttribute('aria-busy', 'true');
      hent(panel);
    }
  });

  function init() {
    var skall = document.querySelectorAll(SKALL);
    if (!skall.length) return;

    for (var i = 0; i < skall.length; i++) {
      synlighet.observe(skall[i], { attributes: true, attributeFilter: ['hidden'] });
    }

    var seksjoner = Array.prototype.slice.call(document.querySelectorAll(SEKSJON)).filter(function (s) {
      return s.querySelector(SKALL);
    });

    if (!('IntersectionObserver' in window)) {
      seksjoner.forEach(hentSeksjon);
      return;
    }

    var naer = new IntersectionObserver(function (oppforinger) {
      oppforinger.forEach(function (o) {
        if (!o.isIntersecting) return;
        naer.unobserve(o.target);
        hentSeksjon(o.target);
      });
    }, { rootMargin: '600px 0px' });

    seksjoner.forEach(function (s) { naer.observe(s); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
